 function isDarkColor(hexColor: string) {
  hexColor = hexColor.replace('#', '');

  var r = parseInt(hexColor.slice(0, 2), 16);
  var g = parseInt(hexColor.slice(2, 4), 16);
  var b = parseInt(hexColor.slice(4, 6), 16);

  var luminance = 0.299 * r + 0.587 * g + 0.114 * b;

  return luminance < 128;
}

export function getContrastColor(hexColor: string) {
  return isDarkColor(hexColor) ? 'white' : 'black';
}
